import Http from '@/api/http.js'

export default {
  
  index(params){
    return Http.get(`/agenda`, {params});
  },


  
}